/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-02T16:50:00+05:00
Intent: The value is escaped before the search term is marked, so HTML typed into a field (e.g. a campaign name) shows as text and never renders or runs.
A count or amount of 0 shows as 0 instead of an empty cell.
*/
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { escapeHtml } from '../utils/html-escape.util';

@Pipe({
  name: 'highlight',
  pure: false
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, search: string): SafeHtml {
    // Empty values show nothing, but a 0 (e.g. Participants) is a real value and shows.
    if (!value && value !== 0) return '';

    const stringValue = value.toString();
    let newValue = escapeHtml(stringValue);

    if (search) {
      // Match on the raw text, then escape each piece, so a term like "amp" never lands inside "&amp;"
      const pattern = search.toString().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      const regex = new RegExp(pattern, 'gi');
      let last = 0;
      newValue = '';
      for (const match of stringValue.matchAll(regex)) {
        const start = match.index ?? 0;
        newValue += escapeHtml(stringValue.slice(last, start))
          + `<span class="highlight-text" style="text-transform: none !important;">${escapeHtml(match[0])}</span>`;
        last = start + match[0].length;
      }
      newValue += escapeHtml(stringValue.slice(last));
    }

    // wrap entire text to preserve original case
    return this.sanitizer.bypassSecurityTrustHtml(`<span style="text-transform: none !important;">${newValue}</span>`);
  }
}
